import { render, staticRenderFns } from "./MovedAbroadYN.vue?vue&type=template&id=a6b60e80"
import script from "./MovedAbroadYN.vue?vue&type=script&lang=js"
export * from "./MovedAbroadYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports